export { AccountSendersItem as default };

/**
* Account Senders Item
*
* Represents an Email Address in an Account Senders List (Whitelist/Blacklist)
*
* @author      Ruben Simões<ruben.r.simoes@meo.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class AccountSendersItem
{
  /**
   * Email sender
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  sender;

  /**
   * The status of the sender in the list
   *
   * @type {Number} 1 - active | 0 - not active | -1 - not sync with redis~
   *
   * @since 7.0.0
   */
  status;

  /**
   * Type of list that the sender belongs to
   *
   * @type {String} 'WHITELIST' | 'BLACKLIST'
   *
   * @since 7.0.0
   */
  type;

  /**
   * Rule associated with the sender
   *
   * @type {String} 'address' | 'domain'
   *
   * @since 7.0.0
   */
  rule;
}